import { Injectable } from '@angular/core';

import { select, Store, Action } from '@ngrx/store';
import { filter } from 'rxjs/operators';

import * as fromApp from './app.reducer';
import * as AppSelectors from './app.selectors';
import * as AppActions from './app.actions';
import { BrandService } from '../../services/brand.service';

@Injectable()
export class AppFacade {
  appState$ = this.store.pipe(select(AppSelectors.getAppState));
  loading$ = this.store.pipe(select(AppSelectors.getAppLoading));
  layout$ = this.store.pipe(
    select(AppSelectors.getLayout),
    filter(l => !!l)
  );

  constructor(
    private store: Store<fromApp.AppPartialState>,
    private brandService: BrandService
  ) {}

  dispatch(action: Action) {
    this.store.dispatch(action);
  }

  loadApp() {
    this.dispatch(AppActions.loadApp());
  }

  openShop() {
    this.brandService.goToShop();
  }

  goToStripeDashboard() {
    this.store.dispatch(AppActions.goToStripeDashboard());
  }

  goToContactUs() {
    this.brandService.goToContactUs();
  }

  clickTopAction() {
    this.brandService.clickTopAction();
  }

  clickLogo() {
    this.brandService.clickLogo();
  }
}
